import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
    GradePostCompleteStatus,
    GradeValidationStatus,
    GradeValidationStatusDetail, GradeValidationStatusDetailList
} from './interface/grade-validation.interface';

@Injectable()
export class GradeValidationService {
    constructor(private http: HttpClient) {}

    getByRosterPostStatus(transactionId: string): Observable<GradeValidationStatus> {
        return this.http.get<GradeValidationStatus>(
            '/api/courseStudentGradeValidation/getByRosterPostStatus/' + transactionId
        );
    }

    getPostStatusDetail(transactionId: string): Observable<GradeValidationStatusDetailList> {
        return this.http.get<GradeValidationStatusDetailList>('/api/courseStudentGradeValidation/' + transactionId);
    }

    getPostCompleteDetail(transactionId: string): Observable<GradePostCompleteStatus> {
        return this.http.get<GradePostCompleteStatus>('/api/courseStudentGradePostComplete/' + transactionId);
    }
}
